import React, { useState } from "react";
import styles from "./AutomaticBillPayementContent.module.css";
import { url} from "../../Values/constants";
import axiosHandler from "../../Services/axiosHandler";
import { connect, useDispatch } from "react-redux";
import { pushToGA } from "../../Services/users";

interface AutomaticBillPayementContentProps { 
  setOpenSetUpAutoPayModal: (open: boolean) => void;
  PayModal: (open: boolean) => void;
  setRecr?: (open: any) => void;
  user?: any;
  offerPrice?:any;
  originalPrice?:any;
  packageId?:any;
  setOpenTryAutoPayModal?: (open: boolean) => void;
}

const AutomaticBillPayementContent: React.FC<AutomaticBillPayementContentProps> = ({setOpenSetUpAutoPayModal,setRecr,setOpenTryAutoPayModal, PayModal,user,originalPrice,offerPrice,packageId}) => {
  
const normalPayHandler = () => {
  pushToGA(
    "event_tracking",
    "read pro",
    "read pro",
    "whatsapp popup | cta :Continue with 1 time Recharge click",
    user,
    // eventLabel ? eventLabel : ""
  )
  setOpenSetUpAutoPayModal(false);
  PayModal(true);
  if(setRecr){setRecr("N")}
  if (setOpenTryAutoPayModal) {
    setOpenTryAutoPayModal(false);
  }
  document.body.classList.add("no-overflow");
};

const setUpAutoPayHandler = () => {
  pushToGA(
    "event_tracking",
    "read pro",
    "read pro",
    "whatsapp popup | cta :Setup Autopay click",
    user,
    // eventLabel ? eventLabel : ""
  )
  setOpenSetUpAutoPayModal(true);
  if(setRecr){setRecr("Y")}
  if (setOpenTryAutoPayModal) {
    setOpenTryAutoPayModal(false);
  }
  // PayModal(false);
  document.body.classList.add("no-overflow");
};

  return (
    <div className={styles.AtmbilpayContent}>
      <div className={styles.AtmbilpayImageBox}></div>
      <div className={styles.AtmbilpayTitle}>Try Automatic Bill payments</div>
      <div className={styles.AtmbilpayHighlights}>
        <div className={styles.AtmbilpayHighlight}>
          <div className={styles.AtmbilpayHighlightLabel}>Uninterrupted Service</div>
          <div className={`${styles.AtmbilpayHighlightData} ${styles.Communication}`}>Never miss on any potential customer with uninterrupted communication.</div>
        </div>
        <div className={styles.AtmbilpayHighlight}>
          <div className={styles.AtmbilpayHighlightLabel}>Hassle Free Payment</div>
          <div className={`${styles.AtmbilpayHighlightData} ${styles.AutoPay}`}>Set your automatic payments once and let ReadPRO worry about your bills and payments.</div>
        </div>
        <div className={styles.AtmbilpayHighlight}>
          <div className={styles.AtmbilpayHighlightLabel}>Easy Setup</div>
          <div className={`${styles.AtmbilpayHighlightData} ${styles.Satisfaction}`}>Automatic payment setup is easy & takes only a few steps. You can choose several payment options - UPI, Debit Card, Credit Card, etc.</div>
        </div>
      </div>
      <div className={styles.AtmbilpayActns}>
        <span className={`${styles.AtmbilpayCtaFilled} CtaFilled`} onClick={()=>setUpAutoPayHandler()}>Setup  Autopay</span>
        <span className={`${styles.AtmbilpayCtaOutlined} CtaOutlined`} onClick={()=>normalPayHandler()}>Continue with 1 time Recharge</span>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
  };
};

// export default AutomaticBillPayementContent;
export default connect(mapStateToProps)(AutomaticBillPayementContent);
